import { Link } from 'react-router-dom'

import githubSvg from './css/github.svg';
import linkedinSvg from './css/linkedin.svg';

export default function Contact(){
    return (
        <div className='contact-container'>
            <h1>Contact</h1>

            <a>contact@frezee.net</a>

            <div className="social-links-contact">
                <Link to={"https://www.linkedin.com/in/james-samuel-wheeler/"}><img src={linkedinSvg} alt={"linkedin logo"}/></Link>
                <Link to={"https://github.com/FrezeeOfficial"}><img src={githubSvg} alt={"github logo"}/></Link>
            </div>
        </div>
    )
}